module.exports = __webpack_public_path__ + "img/arrow-down.da2ee4be.svg";